<form [formGroup]="generalForm" (ngSubmit)="processForm()" novalidate>
    @if (error) {
        <section class="alert alert-danger" role="alert">
            <div>{{ error }}</div>
        </section>
    }

    @if (fullAddress) {
        <span class='cc-form name-inputs' [formGroup]="nameForm">
            @if (isCheck === false) {
                <div class="form-group" [ngClass]="{
                'has-error': firstName.invalid && firstName.dirty
            }">
                    <label for="cc-first-name">First Name *</label>
                    <input class="form-control" id="cc-first-name" formControlName="firstName" autocomplete="off"
                        ccFirstName>
                    @if (firstName.errors && firstName.invalid && firstName.dirty) {
                        <div class="help-block" id="helpBlockFirstName">
                            @if (firstName.errors['required']) {
                                <p>First name is required.</p>
                            }
                        </div>
                    }
                </div>

                <div class="form-group" [ngClass]="{
                'has-error': lastName.invalid && lastName.dirty
            }">
                    <label for="cc-first-name">Last Name *</label>
                    <input class="form-control" id="cc-last-name" formControlName="lastName" autocomplete="off" ccFirstName>
                    @if (lastName.errors && lastName.invalid && lastName.dirty) {
                        <div class="help-block" id="helpBlockLastName">
                            @if (lastName.errors['required']) {
                                <p>Last name is required.</p>
                            }
                        </div>
                    }
                </div>
            } @else {
                <div class="form-group" [ngClass]="{
                    'has-error': nameOnAccount.invalid && nameOnAccount.dirty
                }">
                        <label for="cc-name-on-account">Name on Account *</label>
                        <input class="form-control" id="cc-name-on-account" formControlName="nameOnAccount" autocomplete="off"
                            ccNameOnAccount>
                        @if (nameOnAccount.errors && nameOnAccount.invalid && nameOnAccount.dirty) {
                            <div class="help-block" id="helpBlockNameOnAccount">
                                @if (nameOnAccount.errors['required']) {
                                    <p>Name On Account is required.</p>
                                }
                            </div>
                        }
                    </div>
            }
        </span>
    }

    @if (type === 'fiserv') {
        <span class='cc-form card-connect-inputs'>
            @if (showCheckToggle && showCreditCard) {
                <div class="form-group" [formGroup]="generalForm">
                    <div>
                        <label>
                            <input name="payment-type" type="radio" [value]="false"
                                formControlName="paymentType" name="paymentType" />
                            <span>Credit Card</span>
                        </label>
                    </div>
                    <div>
                        <label>
                            <input name="payment-type" type="radio" [value]="true"
                                formControlName="paymentType" name="paymentType" />
                            <span>ECheck</span>
                        </label>
                    </div>
                </div>
            }
            @if (isCheck === false) {
                <span>
                    <iframe id="tokenFrame" name="tokenFrame" [src]="ccIFrameUrl" frameborder="0" scrolling="no" width="100%"
                        height="220"></iframe>
                    @if (iframeErrors.length) {
                        <div class="iframe-errors">
                            @for (iframeError of iframeErrors; track iframeError) {
                                <div>{{ iframeError.message }}</div>
                            }
                        </div>
                    }
                </span>
            }
            @if (isCheck === true) {
                <span [formGroup]="checkForm">
                    <label id="acctTypeGroupLabel">Account Type *</label>
                    @if (showAcctType) {
                        <div class="form-group" [ngClass]="{
                            'has-error': acctTypeControl.invalid && (acctTypeControl.dirty || acctTypeControl.touched)
                          }">
                            <div>
                                <label>
                                    <input type="radio" value="ECHK|P" formControlName="acctType" />
                                    <span>Personal Checking Account</span>
                                </label>
                            </div>
                            <div>
                                <label>
                                    <input type="radio" value="ESAV|P" formControlName="acctType" />
                                    <span>Personal Savings Account</span>
                                </label>
                            </div>
                            <div>
                                <label>
                                    <input type="radio" value="ECHK|B" formControlName="acctType" />
                                    <span>Business Checking Account</span>
                                </label>
                            </div>
                            <div>
                                <label>
                                    <input type="radio" value="ESAV|B" formControlName="acctType" />
                                    <span>Business Savings Account</span>
                                </label>
                            </div>
                            @if (acctTypeControl && acctTypeControl.errors && acctTypeControl.invalid && acctTypeControl.dirty) {
                                <div class="help-block" id="helpBlockAcctType">
                                    @if (acctTypeControl.errors['required']) {
                                        <p>Account type is required.</p>
                                    }
                                </div>
                            }
                        </div>
                    }
                    <div class="form-group" [ngClass]="{
                        'has-error': routing.invalid && (routing.dirty || routing.touched)
                      }">
                        <label for="routing-number">Routing Number *</label>
                        <input class="form-control" id="rounting-number" formControlName="routing" type="tel" autocomplete="off"
                            data-private />
                        @if (routing && routing.errors && routing.invalid && routing.dirty) {
                            <div class="help-block" id="helpBlockRouting">
                                @if (routing.errors['required']) {
                                    <p>Routing number is required.</p>
                                }
                                @if (routing.errors['minlength']) {
                                    <p>Routing number must be
                                        {{routing.errors['minlength'].requiredLength}} characters long.</p>
                                }
                                @if (routing.errors['maxlength']) {
                                    <p>Routing number must be
                                        {{routing.errors['maxlength'].requiredLength}} characters long.</p>
                                }
                            </div>
                        }
                    </div>
                    <div class="form-group" [ngClass]="{
                        'has-error': account && account.invalid && (account.dirty || account.touched)
                      }">
                        <label for="account-number">Account Number *</label>
                        <input class="form-control" id="account-number" formControlName="account" type="tel" autocomplete="off"
                            data-private />
                        @if (account && account.errors && account.invalid && account.dirty) {
                            <div class="help-block" id="helpBlockAccount">
                                @if (account.errors['required']) {
                                    <p>Account number is required.</p>
                                }
                                @if (account.errors['minlength']) {
                                    <p>Account number must be at least
                                        {{account.errors['minlength'].requiredLength}} characters long.</p>
                                }
                                @if (account.errors['maxlength']) {
                                    <p>Account number must be at most
                                        {{account.errors['maxlength'].requiredLength}} characters long.</p>
                                }
                            </div>
                        }
                    </div>
                </span>
            }
        </span>
    }
    @if (type === 'hps') {
        <span class='cc-form hps-inputs' [formGroup]="hpsForm">
            <div class="form-group" [ngClass]="{
                'has-error': number.invalid && (number.dirty || number.touched)
              }">
                <label for="cc-number">Card Number *</label>
                <input class="form-control" id="cc-number" formControlName="number" type="tel" autocomplete="cc-number"
                    mask="{{ cardNumberMask }}"
                    [dropSpecialCharacters]="false"
                    (input)="onCardNumberChange($event)"
                    aria-describedby="helpBlockNumber" aria-required="true"
                    [attr.aria-invalid]="submitted && number.invalid" data-private />
                @if (number.errors && number.invalid && number.dirty) {
                    <div class="help-block" id="helpBlockNumber">
                        @if (number.errors['required']) {
                            <p>Number is required</p>
                        }
                        @if (!number.errors['required'] && number.errors['ccNumber']) {
                            <p>Card number is invalid.</p>
                        }
                        @if (number.errors['hps']) {
                            <p>{{ errors.number }}</p>
                        }
                    </div>
                }
            </div>


            <div class="form-group" [ngClass]="{
                'has-error': expiration.invalid && (expiration.dirty || expiration.touched)
              }">
                <label for="cc-exp-date">Expiration Date *</label>
                <input class="form-control" id="cc-exp-date" formControlName="expiration" type="tel" autocomplete="cc-exp"
                    mask="00/00" [dropSpecialCharacters]="false"  aria-describedby="helpBlockExpiration" aria-required="true"
                    [attr.aria-invalid]="submitted && expiration.invalid" data-private />
                @if (expiration.errors && expiration.invalid && expiration.dirty) {
                    <div class="help-block" id="helpBlockExpiration">
                        @if (expiration.errors['required']) {
                            <p>Card expiration is required</p>
                        }
                        @if (!expiration.errors['required'] && expiration.errors['expDate']) {
                            <p>Card expiration is invalid.</p>
                        }
                        @if (expiration.errors['hps']) {
                            <p>{{ errors.expiration }}</p>
                        }
                    </div>
                }
            </div>

            <div class="form-group" [ngClass]="{
                'has-error': cvc.invalid && cvc.dirty
              }">
                <label for="cc-cvc">Security Code *</label>
                <input class="form-control" id="cc-cvc" formControlName="cvc" type="tel" autocomplete="off"
                    mask="{{ cvcMask }}" [dropSpecialCharacters]="false"
                    data-private>
                @if (cvc.errors && cvc.invalid && cvc.dirty) {
                    <div class="help-block" id="helpBlockCvc">
                        @if (cvc.errors['required']) {
                            <p>Card verification number is required. It can be found on the back of
                                your card and is 3 or 4 numbers.</p>
                        }
                    </div>
                }
            </div>
        </span>
    }

    @if (fullAddress) {
        <span class='cc-form address-inputs' [formGroup]="addressForm">
            <div class="form-group" [ngClass]="{
                'has-error': line1.invalid && line1.dirty
            }">
                <label for="cc-line1">Billing Address *</label>
                <input class="form-control" id="cc-line1" formControlName="line1" type="text" autocomplete="off" ccLine1
                    #addressInput>

                @if (line1.errors && line1.invalid && line1.dirty) {
                    <div class="help-block" id="helpBlockLine1">
                        @if (line1.errors['required']) {
                            <p>Billing address is required.</p>
                        }
                    </div>
                }
            </div>

            <div class="form-group" [ngClass]="{
                'has-error': city.invalid && city.dirty
            }">
                <label for="cc-city">City *</label>
                <input class="form-control" id="cc-city" formControlName="city" autocomplete="off" ccCity>
                @if (city.errors && city.invalid && city.dirty) {
                    <div class="help-block" id="helpBlockCity">
                        @if (city.errors['required']) {
                            <p>City is required.</p>
                        }
                    </div>
                }
            </div>

            <div class="form-group" [ngClass]="{
                'has-error': state.invalid && state.dirty
            }">
                <label for="cc-state">State *</label>
                <div>
                    <select class="form-control" id="cc-state" formControlName="state" ccState>
                        <option value="">Select State *</option>
                        @for (stateOption of states; track stateOption.abbr) {
                            <option [ngValue]="stateOption.abbr">{{ stateOption.name }}</option>
                        }
                    </select>
                </div>
                @if (state.errors && state.invalid && state.dirty) {
                    <div class="help-block" id="helpBlockState">
                        @if (state.errors['required']) {
                            <p>State is required.</p>
                        }
                    </div>
                }
            </div>

            <div class="form-group" [ngClass]="{
                'has-error': phone.invalid && phone.dirty
            }">
                <label for="cc-phone">Phone *</label>
                <input class="form-control" id="cc-phone" formControlName="phone" autocomplete="off" ccPhone>
                @if (phone.errors && phone.invalid && phone.dirty) {
                    <div class="help-block" id="helpBlockState">
                        @if (phone.errors['required']) {
                            <p>Phone is required.</p>
                        }
                    </div>
                }
            </div>
        </span>
    }

    <div class="form-group" [ngClass]="{
               'has-error': zip.invalid && zip.dirty
             }">
        <label for="cc-zip">Zip Code *</label>
        <input class="form-control" id="cc-zip" formControlName="zip" type="text" autocomplete="off" ccZip>
        @if (zip.errors && zip.invalid && zip.dirty) {
            <div class="help-block" id="helpBlockZip">
                @if (zip.errors['required']) {
                    <p>Billing zip code is required.</p>
                }
            </div>
        }
    </div>

    <div class="form-group" [ngClass]="{
        'has-error': email.invalid && email.dirty
    }">
        <label for="email">Email (for receipt) *</label>
        <input class="form-control" id="email" formControlName="email" type="email"
            autocomplete="email" aria-describedby="helpBlockEmail" aria-required="true"
            [attr.aria-invalid]="submitted && email.invalid" data-private
            (input)="email.setValue(email.value.trim())"
        >
        @if (email.errors && email.invalid && email.dirty) {
            <div class="help-block" id="helpBlockEmail">
                @if (email.errors['required']) {
                    <p>Email address is required.</p>
                }
            </div>
        }
    </div>

    @if (showCancel) {
        <button class="btn btn-cancel" [disabled]="submitted"
            (click)="$event.preventDefault(); cancelForm()">Cancel</button>
    }
    <button type="submit" class="btn btn-success"
        [disabled]="submitted || (!tokenData && type === 'fiserv' && !isCheck)">{{submitText}}</button>
</form>
